import { stringify } from "query-string";

export const LP_HOST = "https://www.lonelyplanet.com";
export const AUTH_HOST = "https://connect.lonelyplanet.com";
export const IMGIX_HOST = "https://lonelyplanetstatic.imgix.net";
export const SHOP_HOST = "https://shop.lonelyplanet.com";
export const SEARCH_HOST = `${LP_HOST}/search`;
export const VIDEO_HOST = `${LP_HOST}/video`;
export const PROFILE_HOST = `${LP_HOST}/profile`;
export const THORNTREE_HOST = `${LP_HOST}/thorntree`;

const baseMenu = {
  items: [
    {
      title: "Search",
      url: SEARCH_HOST,
    },
    {
      title: "Video",
      url: `${VIDEO_HOST}`,
      submenu: {
        featured: {
          image: `${IMGIX_HOST}/op-video-sync/assets/bit19_masthead.jpg?w=80&h=60&fit=min`,
          title: "Best in Travel 2019",
          subtitle: "Featured",
          url: `${VIDEO_HOST}/best-in-travel-2019/v/cha/14`,
        },
        items: [
          {
            title: "Adventure travel",
            url: `${VIDEO_HOST}/adventure-travel/v/cha/1`,
          },
          {
            title: "Art and culture",
            url: `${VIDEO_HOST}/art-and-culture/v/cha/2`,
          },
          {
            title: "Beaches, coasts and islands",
            url: `${VIDEO_HOST}/beaches/v/cha/3`,
          },
          {
            title: "Explore Abu Dhabi",
            url: `${VIDEO_HOST}/explore-abu-dhabi/v/cha/12`,
          },
          {
            title: "Explore every day",
            url: `${VIDEO_HOST}/explore-every-day/v/cha/4`,
          },
          {
            title: "Food and drink",
            url: `${VIDEO_HOST}/food-and-drink/v/cha/7`,
          },
          {
            title: "Journeys",
            url: `${VIDEO_HOST}/journeys/v/cha/9`,
          },
          {
            title: "Tokyo Modern | Classic",
            url: `${VIDEO_HOST}/tokyo-modern-classic/v/cha/13`,
          },
        ],
        call_to_action: {
          url: `${VIDEO_HOST}`,
          title: "Browse Videos",
        },
      },
    },
    {
      title: "Destinations",
      url: `${LP_HOST}/places`,
      submenu: {
        featured: {
          image: `${IMGIX_HOST}/marketing/2018/BIT/BIT-nav-image.jpg?w=80&h=60&fit=min`,
          title: "Best in Travel",
          subtitle: "Featured",
          url: `${LP_HOST}/best-in-travel`,
        },
        items: [
          {
            title: "Africa",
            url: `${LP_HOST}/africa`,
          },
          {
            title: "Antarctica",
            url: `${LP_HOST}/antarctica-1007062`,
          },
          {
            title: "Asia",
            url: `${LP_HOST}/asia`,
          },
          {
            title: "Australia & Pacific",
            url: `${LP_HOST}/pacific`,
          },
          {
            title: "Caribbean",
            url: `${LP_HOST}/caribbean`,
          },
          {
            title: "Central America",
            url: `${LP_HOST}/central-america`,
          },
          {
            title: "Europe",
            url: `${LP_HOST}/europe`,
          },
          {
            title: "Middle East",
            url: `${LP_HOST}/middle-east`,
          },
          {
            title: "North America",
            url: `${LP_HOST}/north-america`,
          },
          {
            title: "South America",
            url: `${LP_HOST}/south-america`,
          },
        ],
        call_to_action: {
          url: `${LP_HOST}/places`,
          title: "See All Countries",
        },
      },
    },
    {
      title: "Bookings",
      url: `${LP_HOST}/bookings`,
      submenu: {
        items: [
          {
            title: "Insurance",
            url: `${LP_HOST}/travel-insurance`,
          },
          {
            title: "Hotels",
            url: `${LP_HOST}/hotels`,
          },
          {
            title: "Flights",
            url: `${LP_HOST}/flights`,
          },
          {
            title: "Adventure tours",
            url: `${LP_HOST}/adventure-tours`,
          },
          {
            title: "Sightseeing tours",
            url: `${LP_HOST}/sightseeing-tours`,
          },
          {
            title: "Car rental",
            url: `${LP_HOST}/car-rental`,
          },
        ],
      },
    },
    {
      title: "Shop",
      url: SHOP_HOST,
    },
  ],
};

const getSignInItem = () => ({
  title: "Sign in",
  url: `${AUTH_HOST}/oauth/authorize?${stringify({
    client_id: "foymu5r6sscxe",
    scope: "openid",
    redirect_uri: `${AUTH_HOST}/sso`,
    target_link_uri:
      typeof window === "undefined" ? null : window.location.href,
    auth_method: null,
    response_type: "code",
    prompt: "login",
  })}`,
});

const getUserSettingsItem = (user) => ({
  title: "Settings",
  url: `${PROFILE_HOST}/${user.id}/edit`,
});

const getUserProfileItem = (user) => ({
  title: "Profile",
  url: `${PROFILE_HOST}/${user.username}`,
});

const getUserListsItem = (user) => ({
  title: "Lists",
  url: `${PROFILE_HOST}/${user.username}/lists`,
});

const thornTreeItem = {
  title: "Thorn Tree",
  url: `${THORNTREE_HOST}`,
};

const messagesItem = {
  title: "Messages",
  url: `${THORNTREE_HOST}/messages`,
};

const signOutItem = {
  title: "Sign out",
  url: `${AUTH_HOST}/users/sign_out`,
};

const getUserDesktopMenu = (user) => {
  const userSettingsItem = getUserSettingsItem(user);

  return {
    ...userSettingsItem,
    submenu: {
      items: [
        userSettingsItem,
        getUserProfileItem(user),
        getUserListsItem(user),
        thornTreeItem,
        messagesItem,
        signOutItem,
      ],
    },
  };
};

const getUserMobileMenu = (user) => ({
  items: [getUserListsItem(user), thornTreeItem, messagesItem, signOutItem],
});

export default {
  baseMenu,
  getSignInItem,
  getUserDesktopMenu,
  getUserMobileMenu,
  getUserProfileItem,
  getUserSettingsItem,
};
